export const API_URL = '/api/v2';
export const PUBLIC_API_URL = '/api';
